import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataComparisonInfo } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function ComparisonTargetValue(props: IElementDataComparisonInfo) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { metricTileDisplayVarianceTargetValueFormatted, isReportMetric, settings } = props;
    const fieldKey: ElementMetadataFieldName = 'comparison_info';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !isReportMetric || !metricTileDisplayVarianceTargetValueFormatted) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t('element_data_label.target_value')}</ElementDataRowLabel>
            <ElementDataRowValue>{metricTileDisplayVarianceTargetValueFormatted}</ElementDataRowValue>
        </ElementDataRow>
    );
}
